// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__1wJQB","row":"style_row__OSw-Q","title":"style_title__H0YvT","outlined":"style_outlined__3xmOC"};